import { MAX_LIGHT_POSITION, MAX_SOLID_POSITION } from './Icon';
export var correctIconPosition = function (position, weight) {
    if (weight === 'light' && position > MAX_LIGHT_POSITION) {
        return MAX_LIGHT_POSITION;
    }
    if (weight === 'solid' && position > MAX_SOLID_POSITION) {
        return MAX_SOLID_POSITION;
    }
    return position;
};
